import React from "react";
import Navigation from "./Navigation";
import { Outlet } from "react-router-dom";

export default function WartaLayout() {
  return (
    <div>
      <Navigation>
        <Outlet />
      </Navigation>
    </div>
  );
}
